export const sentenceCase = (s?: string) => {
  const safeString = (s || '').toString();

  return `${safeString.charAt(0).toUpperCase()}${safeString.slice(1).toLowerCase()}`;
};

export const emptyObject = {};
